import GenericAPI, { CONTENT_TYPE } from "../GenericApi";
import {
    clearAuthCookie,
    clearUserDetailsCookie, deleteEventsFromSession, deleteProductsFromSession,
    setAuthCookie,
    setUserDetailsCookie
} from "../Utils/apiUtils";

class IdentityApi extends GenericAPI {

    GET_TOKEN_ENDPOINT="/Token"
    USER_ENDPOINT="/api/user"
    VERIFY_OTP_ENDPOINT= "/api/user/verifyOtp"
    RESEND_OTP_ENDPOINT= "/api/user/resendOtp"

    async getToken(username, password){
        const payload= {
            grant_type: 'password',
            username,
            password
        }
        return this.post(this.GET_TOKEN_ENDPOINT, payload, CONTENT_TYPE.URLENCODED);
    }

    async getRefreshToken(refresh_token){
        const payload= {
            grant_type: 'password',
            refresh_token
        }
        return this.post(this.GET_TOKEN_ENDPOINT, payload, CONTENT_TYPE.URLENCODED);
    }

    async login(data){
        const { emailAddress, password, userType } = data;
        const payload= {
            emailAddress,
            password,
            userType,
            playerId: '',
            deviceType: 'Web',
            deviceId: '',
        }
        return this.get(this.USER_ENDPOINT, payload)
            .then(response => {
                if(response.success === 'true') {
                    const userDetails = response.objectVal.userResponse;
                    return this.getToken(emailAddress, userDetails.id)
                        .then(tokenResponse => {
                            setAuthCookie(tokenResponse);
                            setUserDetailsCookie(userDetails);
                            return response;
                        });
                }
                return response;
            });
    }

    async register(payload) {
        return this.post(this.USER_ENDPOINT, payload, CONTENT_TYPE.MULTIPART)
            .then(response => {
                if(response.success === 'true') {
                    const userDetails = response.objectVal.userResponse;
                    return this.getToken(payload.emailAddress, userDetails.id)
                        .then(tokenResponse => {
                            setAuthCookie(tokenResponse);
                            userDetails.token = tokenResponse;
                            setUserDetailsCookie(userDetails);
                            return response;
                        });
                }
                return response;
            });
    }

    async updateProfile(payload) {
        return this.post(this.USER_ENDPOINT, payload, CONTENT_TYPE.MULTIPART);
    }

    async resetPassword(emailAddress){
        const payload= {
            emailAddress
        }
        return this.post(this.USER_ENDPOINT, payload, null);
    }

    async updatePassword(userid, oldpassword, newpassword ){
        const payload= {
            userid,
            oldpassword,
            newpassword
        }
        return this.post(this.USER_ENDPOINT, payload, CONTENT_TYPE.URLENCODED);
    }

    async verifyOtp(userId, otpNumber){
        const payload= {
            userId,
            otpNumber
        }
        return this.get(this.VERIFY_OTP_ENDPOINT, payload, true);
    }

    async resendOtp(userId){
        const payload= {
            userId
        }
        return this.post(this.RESEND_OTP_ENDPOINT, payload, CONTENT_TYPE.URLENCODED,true);
    }

    async logout(){
        clearAuthCookie();
        clearUserDetailsCookie();
        deleteEventsFromSession();
        deleteProductsFromSession();
    }
}

export default new IdentityApi();
